import dateFns from 'date-fns/locale/bg';

export default {
  dateFns,

  format: {
    date: 'd.MM.yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd. MMM',
    longDateTime: "d. MMMM 'в' p",
    fullDate: 'd. MMM. y',
    fullDateTime: "d. MMMM. y 'в' p",
  },

  translation: {
    common: {
      aboutPlanka: 'За Planka',
      account: 'Акаунт',
      actions: 'Действия',
      addAttachment_title: 'Добавяне на прикачен файл',
      addComment: 'Добавяне на коментар',
      addManager_title: 'Добавяне на мениджър',
      addMember_title: 'Добавяне на член',
      addUser_title: 'Добавяне на потребител',
      administrator: 'Администратор',
      all: 'Всички',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Всички промени ще бъдат автоматично запазени<br />след възстановяване на връзката.',
      areYouSureYouWantToDeleteThisAttachment:
        'Сигурни ли сте, че искате да изтриете този прикачен файл?',
      areYouSureYouWantToDeleteThisBoard: 'Сигурни ли сте, че искате да изтриете това табло?',
      areYouSureYouWantToDeleteThisCard: 'Сигурни ли сте, че искате да изтриете тази карта?',
      areYouSureYouWantToDeleteThisComment: 'Сигурни ли сте, че искате да изтриете този коментар?',
      areYouSureYouWantToDeleteThisLabel: 'Сигурни ли сте, че искате да изтриете този етикет?',
      areYouSureYouWantToDeleteThisList: 'Сигурни ли сте, че искате да изтриете този списък?',
      areYouSureYouWantToDeleteThisProject: 'Сигурни ли сте, че искате да изтриете този проект?',
      areYouSureYouWantToDeleteThisTask: 'Сигурни ли сте, че искате да изтриете тази задача?',
      areYouSureYouWantToDeleteThisUser: 'Сигурни ли сте, че искате да изтриете този потребител?',
      areYouSureYouWantToLeaveBoard: 'Сигурни ли сте, че искате да напуснете таблото?',
      areYouSureYouWantToLeaveProject: 'Сигурни ли сте, че искате да напуснете проекта?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Сигурни ли сте, че искате да премахнете този мениджър от проекта?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Сигурни ли сте, че искате да премахнете този член от таблото?',
      attachment: 'Прикачен файл',
      attachments: 'Прикачени файлове',
      authentication: 'Удостоверяване',
      background: 'Фон',
      board: 'Табло',
      boardNotFound_title: 'Таблото не е намерено',
      canComment: 'може да коментира',
      canEditContentOfBoard: 'може да редактира съдържание на таблото',
      canOnlyViewBoard: 'може само да преглежда таблото',
      cardActions_title: 'Действия с карта',
      cardNotFound_title: 'Картата не може да бъде открита',
      cardOrActionAreDeleted: 'Картата или действието са изтрити.',
      color: 'Цвят',
      copy_inline: 'копирай',
      createBoard_title: 'Създаване на табло',
      createLabel_title: 'Създаване на етикет',
      createNewOneOrSelectExistingOne: 'Създайте нов или изберете<br/>съществуващ.',
      createProject_title: 'Създаване на проект',
      createTextFile_title: 'Създаване на текстов файл',
      currentPassword: 'Текуща парола',
      dangerZone_title: 'Опасна зона',
      date: 'Дата',
      dueDate: 'Дата на падежа',
      dueDate_title: 'Краен срок',
      deleteAttachment_title: 'Изтриване на прикачен файл',
      deleteBoard_title: 'Изтриване на табло',
      deleteCard_title: 'Изтриване на карта',
      deleteComment_title: 'Изтриване на коментар',
      deleteLabel_title: 'Изтриване на етикета',
      deleteList_title: 'Изтриване на списък',
      deleteProject_title: 'Изтриване на проект',
      deleteTask_title: 'Изтриване на задача',
      deleteUser_title: 'Изтриване на потребител',
      description: 'Описание',
      detectAutomatically: 'Aвтоматично откриване',
      dropFileToUpload: 'Пуснете файл за качване',
      editor: 'Редактор',
      editAttachment_title: 'Редактирай прикачения файл',
      editAvatar_title: 'Редактиране на аватар',
      editBoard_title: 'Редактиране на табло',
      editDueDate_title: 'Редактиране на дата на падеж',
      editEmail_title: 'Редактиране на имейл',
      editInformation_title: 'Редактиране на информация',
      editLabel_title: 'Редактиране на табло',
      editPassword_title: 'Редактиране на парола',
      editPermissions_title: 'Редактиране на права',
      editStopwatch_title: 'Редактиране на Хронометър',
      editUsername_title: 'Редактиране на потребителско име',
      email: 'Имейл',
      emailAlreadyInUse: 'Имейлът вече се използва',
      enterCardTitle: 'Въведете заглавие на картата... [Ctrl+Enter] за автоматично отваряне.',
      enterDescription: 'Въведете описание...',
      enterFilename: 'Въведете име на файла',
      enterListTitle: 'Въведете заглавие на списък...',
      enterProjectTitle: 'Въведете заглавие на проекта',
      enterTaskDescription: 'Въведете описание на задачата...',
      filterByLabels_title: 'Филтриране по етикети',
      filterByMembers_title: 'Филтриране по членове',
      fromComputer_title: 'От компютър',
      fromTrello: 'От Trello',
      general: 'Общ',
      hours: 'Часове',
      importBoard_title: 'Импортиране на табло',
      invalidCurrentPassword: 'Невалидна текуща парола',
      labels: 'Етикети',
      language: 'Език',
      leaveBoard_title: 'Напуснете таблото',
      leaveProject_title: 'Напуснете проекта',
      list: 'Списък',
      listActions_title: 'Списък с действия',
      managers: 'Мениджъри',
      managerActions_title: 'Действия с мениджъри',
      members: 'Членове',
      memberActions_title: 'Действия с членове',
      minutes: 'Минути',
      moveCard_title: 'Преместване на карта',
      name: 'Име',
      newestFirst: 'Първо най-новите',
      newEmail: 'Нов имейл',
      newPassword: 'Нова парола',
      newUsername: 'Ново потребителско име',
      noConnectionToServer: 'Няма връзка със сървъра',
      noBoards: 'Няма табла',
      noLists: 'Няма списъци',
      noProjects: 'Няма проекти',
      notifications: 'Уведомления',
      noUnreadNotifications: 'Няма непрочетени известия.',
      oldestFirst: 'Първо най-старите',
      openBoard_title: 'Отворете табло',
      optional_inline: 'по желание',
      organization: 'Организация',
      phone: 'Телефон',
      preferences: 'Предпочитания',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Съвет: натиснете Ctrl-V (Cmd-V на Mac), за да добавите прикачен файл от клипборда',
      project: 'Проект',
      projectNotFound_title: 'Проектът не е намерен',
      removeManager_title: 'Премахване на мениджър',
      removeMember_title: 'Премахване на член',
      searchLabels: 'Търсене на етикети...',
      searchMembers: 'Търсене на членове...',
      searchUsers: 'Търсене на потребители...',
      searchCards: 'Търсене на карти...',
      seconds: 'секунди',
      selectBoard: 'Изберете табло',
      selectList: 'Изберете списък',
      selectPermissions_title: 'Изберете правата',
      selectProject: 'Изберете проект',
      settings: 'Настройки',
      sortList_title: 'Сортиране на списък',
      stopwatch: 'Хронометър',
      subscribeToMyOwnCardsByDefault: 'Абонирайте се за собствените си карти по подразбиране',
      taskActions_title: 'Действия със задачи',
      tasks: 'Задачи',
      thereIsNoPreviewAvailableForThisAttachment: 'Няма наличен преглед за този прикачен файл.',
      time: 'Време',
      title: 'Заглавие',
      userActions_title: 'Потребителски действия',
      userAddedThisCardToList: '<0>{{user}}</0><1> добави тази карта в {{list}}</1>',
      userLeftNewCommentToCard: '{{user}} остави нов коментар «{{comment}}» в <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} премести <2>{{card}}</2> от {{fromList}} към {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> премести тази карта от {{fromList}} към {{toList}}</1>',
      username: 'Потребителско име',
      usernameAlreadyInUse: 'Потребителското име вече се използва',
      users: 'Потребители',
      version: 'Версия',
      viewer: 'Зрител',
      writeComment: 'Напишете коментар...',
    },

    action: {
      addAnotherCard: 'Добавяне на друга карта',
      addAnotherList: 'Добавяне на друг списък',
      addAnotherTask: 'Добавяне на друга задача',
      addCard: 'Добавяне на карта',
      addCard_title: 'Добавяне на карта',
      addComment: 'Добавяне на коментар',
      addList: 'Добавяне на списък',
      addMember: 'Добавяне на член',
      addMoreDetailedDescription: 'Добавяне на по-подробно описание',
      addTask: 'Добавяне на задача',
      addToCard: 'Добавяне към карта',
      addUser: 'Добавяне на потребител',
      createBoard: 'Създаване на табло',
      createFile: 'Създаване на файл',
      createLabel: 'Създаване на етикет',
      createNewLabel: 'Създаване на нов етикет',
      createProject: 'Създаване на проект',
      delete: 'Изтриване',
      deleteAttachment: 'Изтриване на прикачения файл',
      deleteAvatar: 'Изтриване на аватар',
      deleteBoard: 'Изтриване на табло',
      deleteCard: 'Изтриване на карта',
      deleteCard_title: 'Изтриване на карта',
      deleteComment: 'Изтриване на коментара',
      deleteImage: 'Изтриване на изображение',
      deleteLabel: 'Изтриване на етикета',
      deleteList: 'Изтриване на списък',
      deleteList_title: 'Изтриване на списък',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Изтриване на проект',
      deleteProject_title: 'Изтриване на проект',
      deleteTask: 'Изтриване на задача',
      deleteTask_title: 'Изтриване на задача',
      deleteUser: 'Изтриване на потребител',
      duplicate: 'Направи дубликат',
      duplicateCard_title: 'Дублирана карта',
      edit: 'Редактиране',
      editDueDate_title: 'Редактиране на краен срок',
      editDescription_title: 'Редактиране на описание',
      editEmail_title: 'Редактиране на имейл',
      editInformation_title: 'Редактиране на информация',
      editPassword_title: 'Редактиране на парола',
      editPermissions: 'Разрешения за редактиране',
      editStopwatch_title: 'Редактиране на хронометър',
      editTitle_title: 'Редактиране на заглавието',
      editUsername_title: 'Редактиране на потребителско име',
      hideDetails: 'Скриване на детайлите',
      import: 'Импортиране',
      leaveBoard: 'Напускане на дъската',
      leaveProject: 'Напускане на проекта',
      logOut_title: 'Излезте',
      makeCover_title: 'Създаване на корица',
      move: 'Преместване',
      moveCard_title: 'Преместване на карта',
      remove: 'Премахване',
      removeBackground: 'Премахване на фона',
      removeCover_title: 'Премахване на корицата',
      removeFromBoard: 'Премахване от борда',
      removeFromProject: 'Премахване от проекта',
      removeManager: 'Премахване на мениджър',
      removeMember: 'Премахване на член',
      save: 'Запазване',
      showAllAttachments: 'Показване на всички прикачени файлове ({{hidden}} скрити)',
      showDetails: 'Показване на подробности',
      showFewerAttachments: 'Показване на по-малко прикачени файлове',
      sortList_title: 'Списък за сортиране',
      start: 'Старт',
      stop: 'Стоп',
      subscribe: 'Абонирайте се',
      unsubscribe: 'Отписване',
      uploadNewAvatar: 'Качване на нов аватар',
      uploadNewImage: 'Качване на ново изображение',
    },
  },
};
